/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <v-overlay :model-value="overlay" class="align-center justify-center">
    <v-progress-circular style="color: rgba(21, 102, 124, 0.9)" indeterminate size="64"></v-progress-circular>
  </v-overlay>
  <v-layout>
    <Header v-on:studyChange="selectStudy"></Header>
    <v-main>
      <v-row no-gutters>
        <v-col sm="12" md="6" lg="8" class="marginZeroPaddingZero" id="mapContainer">
          <v-row no-gutters style="
              height: 30px;
              border-bottom: 2px solid rgb(41, 114, 134);
              background: rgb(240, 240, 240);
            ">
            <v-icon color="rgba(21, 102, 124, 0.9)" style="margin-top: 2px;"
              @click.stop="drawer = !drawer">mdi-view-dashboard-variant</v-icon>
            <span v-if="drawer" style="
                  font-size: 20px;
                  padding-left: 5px;
                  color: rgba(21, 102, 124, 0.9);
									margin-top: 1px;
                "><strong>{{ study + " Data: " }}</strong> {{ startdate + " to " + enddate }}</span>
          </v-row>
          <v-row v-if="drawer" no-gutters style="position: absolute; z-index: 10000; background: white;">
            <v-col>
              <v-table style="width: 100%">
                <thead>
                  <tr>
                    <th class="text-left">
                      SUSPECT <v-icon color="red">mdi-exclamation-thick</v-icon>
                    </th>
                    <th class="text-left">
                      IN REVIEW <v-icon color="turquoise">mdi-help-box</v-icon>
                    </th>
                    <th class="text-left">
                      NO DATA <v-icon color="blue">mdi-database</v-icon>
                    </th>
                    <th class="text-left">
                      VALID
                      <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                    </th>
                    <th class="text-left">
                      GPS DATA
                      <v-icon color="lightgreen">mdi-satellite-variant</v-icon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="text-left">{{ dashboardSuspect || 'No data' }}</th>
                    <th class="text-left">{{ dashboardUnderReview || 'No data' }}</th>
                    <th class="text-left">{{ dashboardNoData || 'No data' }}</th>
                    <th class="text-left">{{ dashboardTaskPct || 'No data' }}</th>
                    <th class="text-left">{{ dashboardGpsData || 'No data' }}</th>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
            <v-icon @click.stop="drawer = !drawer">mdi-close</v-icon>
          </v-row>
          <div style="position: relative; height: 772px;">
            <div id="mapLoader" class="maploadernoshow">
              <div class="bottom-right">
                <div class="clock"></div>
              </div>
            </div>
            <LeafletMap mapId="mapid" :staffId="staffId" :staffName="staffName" :study="study"
              @show-day-tracks="getTracksForDay"></LeafletMap>
          </div>
        </v-col>
        <v-col md="6" lg="4">
          <v-card flat style="height: 210px">
            <v-row no-gutters style="
                height: 30px;
                border-bottom: 2px solid #297286;
                border-right: 2px solid #297286;
                background: #f0f0f0;
              ">
              <span style="
                  font-size: 20px;
                  padding-left: 5px;
                  font-weight: bold;
                  color: rgba(21, 102, 124, 0.9);
									margin-top: 1px;
                ">
                {{ staffName }}
              </span>
              <span style="
                  font-size: 20px;
                  padding-left: 20px;
                  color: rgba(21, 102, 124, 0.9);
									margin-top: 1px;
                ">
                {{ staffIdSummaryHeader }}
              </span>
              <v-spacer></v-spacer>
              <v-icon v-if="summaryView === 'phone'" @click="summaryView = 'phone'"
                style="border-bottom: solid; margin-top: 5px">mdi-monitor-cellphone</v-icon>
              <v-icon v-else @click="summaryView = 'phone'" style="margin-top: 5px">mdi-monitor-cellphone</v-icon>
              <v-icon v-if="summaryView === 'regular'" @click="summaryView = 'regular'"
                style="border-bottom: solid; margin-top: 5px">mdi-account-circle</v-icon>
              <v-icon v-else @click="summaryView = 'regular'" style="margin-top: 5px">mdi-account-circle</v-icon>
              <v-icon v-if="summaryView === 'lastRecieved'" @click="summaryView = 'lastRecieved'"
                style="border-bottom: solid; margin-top: 5px">mdi-information-outline</v-icon>
              <v-icon v-else @click="summaryView = 'lastRecieved'"
                style="margin-top: 5px">mdi-information-outline</v-icon>
            </v-row>
            <v-row no-gutters style="border-right: 2px solid #297286">
              <InterviewerDaySummaryTable :criteria="interviewerDayCriteria" :summaryView="summaryView"
                :lastReceivedC="lastReceivedC"></InterviewerDaySummaryTable>
            </v-row>
          </v-card>
          <v-card flat v-if="dataType == 'Tasks'" :disabled="dataType !== 'Tasks' || dailyCardDisabled">
            <v-row no-gutters style="
                background: rgb(224, 224, 224);
                border-bottom: 2px solid #297286;
                border-top: 2px solid #297286;
                border-right: 2px solid #297286;
              ">
              <v-icon style="width: 5%; margin-top: 7px;" @click="getPreviousDateSimple">mdi-arrow-left</v-icon>
              <div style="width: 89%">
                <VueDatePicker v-model="picker" auto-apply :enable-time-picker="false" arrow-navigation text-input
                  input-class-name="dp-custom-input" menu-class-name="dp-custom-menu" class="myDatePicker"
                  model-type="yyyy-MM-dd" />
              </div>
              <v-icon style="width: 5%; margin-top: 7px;" @click="getNextDateSimple">mdi-arrow-right</v-icon>
            </v-row>
            <v-row no-gutters style="border-right: 2px solid #297286">
              <strong><span style="color: rgba(21, 102, 124, 0.9)" data-cy="suspect-tasks-count">
                  Suspect: {{ getSuspectTaskCount }}</span></strong>
              <span style="color: rgba(21, 102, 124, 0.9); margin-left: 8px" data-cy="total-tasks-count">
                Total: {{ getTotalTaskCount }}</span>
              <v-spacer></v-spacer>
              <v-icon v-on:click="clearDailySortAndFilter()" style="margin-right: 25px">mdi-backup-restore</v-icon>
              <v-icon v-if="type === 'listView'" @click="setToListView()"
                style="border-bottom: solid">mdi-format-list-bulleted-square</v-icon>
              <v-icon v-else @click="setToListView()">mdi-format-list-bulleted-square</v-icon>
              <v-icon v-if="type === 'routeView'" @click="setToRouteView()"
                style="border-bottom: solid">mdi-car</v-icon>
              <v-icon v-else @click="setToRouteView()">mdi-car</v-icon>
              <v-icon v-if="type === 'chartView'" @click="setToCharttView()"
                style="border-bottom: solid">mdi-chart-pie</v-icon>
              <v-icon v-else @click="setToCharttView()">mdi-chart-pie</v-icon>
            </v-row>
            <!-- <v-row no-gutters style="border-bottom: 2px solid #297286"> -->
            <DailyTaskListView v-if="type === 'listView'" ref="dailyTaskListComponent" :study="study"
              v-on:openRecord="taskClick" v-on:getExtra="getEagleDay" @refreshData="refreshData"
              @selectedRowRefresh="updateSelectedRow(selectedRowData)" :startdate="startdate" :enddate="enddate"
              :status="status" :view="view" :spidNumber="spidNumber" :selectedid="selectedid">
            </DailyTaskListView>
            <RouteView v-else-if="type === 'routeView'" :criteria="RouteViewCriteria">
            </RouteView>
            <ChartView v-else-if="type === 'chartView'" :colors="[
              '#0089F7',
              '#E31A1C',
              '#6BA23E',
              '#90268E',
              '#07A599',
              '#D3D3D3',
              '#000000',
              '#FFFF00',
            ]"></ChartView>
          </v-card>
          <v-card flat v-else>
            <v-row no-gutters
              style="border-right: 2px solid #297286; border-top: 2px solid #297286; justify-content: center; color: rgba(21, 102, 124, 0.9);font-size: 20px; font-weight: bold;">
              Client Events
            </v-row>
            <ClientEventsView />
          </v-card>
        </v-col>
      </v-row>

      <v-form style="
          border-bottom: 2px solid #297286;
          border-right: 2px solid #297286;
          border-left: 2px solid #297286;
          background: linear-gradient(0.25turn, #f8f8ff, #e0e0e0, #f8f8ff);
          padding-bottom: 5px;
          min-height: 100px;
        ">
        <v-row>
          <v-col height="100" style="max-width: 100px; min-width: 100px">
            <div class="searchTitle" style="margin-left: 10px">ADVANCED</div>
            <v-switch data-cy="task-query-type" v-model="advancedSearch" style="margin-left: 10px" hide-details
              true-value="true" false-value="false" inset></v-switch>
          </v-col>
          <v-col height="100" style="max-width: 147px; min-width: 147px">
            <div class="searchTitle">DATA</div>
            <v-select v-model="dataType" :items="['Tasks', 'Tracks', 'Events']" class="searchField" density="compact"
              variant="outlined" bg-color="white">
            </v-select>
          </v-col>
          <v-col v-if="dataType == 'Tasks'" style="max-width: 225px; min-width: 225px">
            <div class="searchTitle">STATUS</div>
            <v-select data-cy="query-status-input" class="searchField" v-model="status" :items="statusItems"
              :menu-props="{ maxHeight: '400' }" multiple density="compact" variant="outlined" bg-color="white"
              @update:modelValue="checkIfALL">
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 1">
                  <span>{{ item.title }}</span>
                </v-chip>
                <span v-if="index === 1" class="text-black text-caption align-self-center">
                  (+{{ status.length - 1 }})
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col style="max-width: 200px; min-width: 200px" v-if="(advancedSearch == 'true' || dataType == 'Tracks')">
            <div class="searchTitle">
              STAFF
              <span v-if="dataType == 'Tracks' && selectedid === 'ALLSTAFF'">*REQUIRED*</span>
            </div>
            <v-row>
              <v-col>
                <v-autocomplete placeholder="All" :items="staffItems" v-model="selectedid" item-title="nameFull"
                  item-value="staffId" class="searchField" clearable style="max-height: 40px" variant="outlined"
                  bg-color="white" density="compact"></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col style="max-width: 140px; min-width: 140px" v-if="advancedSearch == 'true' && dataType == 'Tasks'">
            <div class="searchTitle">SPID</div>
            <v-row>
              <v-col>
                <v-text-field data-cy="query-spid-input" v-model="spidNumber" class="searchField" variant="outlined"
                  bg-color="white" density="compact">
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col style="max-width: 173px; min-width: 173px">
            <div class="searchTitle">START DATE</div>
            <v-row>
              <v-col>
                <VueDatePicker v-model="startdate" auto-apply :enable-time-picker="false" arrow-navigation text-input
                  input-class-name="dp-custom-input-bottom" menu-class-name="dp-custom-menu" model-type="yyyy-MM-dd"
                  data-cy="query-start-date" />
              </v-col>
            </v-row>
          </v-col>
          <v-col style="max-width: 173px; min-width: 173px">
            <div class="searchTitle">END DATE</div>
            <v-row>
              <v-col>
                <VueDatePicker v-model="enddate" auto-apply :enable-time-picker="false" arrow-navigation text-input
                  input-class-name="dp-custom-input-bottom" menu-class-name="dp-custom-menu" model-type="yyyy-MM-dd"
                  data-cy="query-end-date" />
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="dataType == 'Tasks'" style="max-width: 85px;">
            <div class="searchTitle">TASKS</div>
            <v-row>
              <v-col>
                <v-btn @click="
                  getTasks();
                addToHistory();
                " style="
                    background: rgba(21, 102, 124, 0.1);
                    border: 2px solid #297286;
                  " variant="outlined" data-cy="query-execute-btn">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="dataType == 'Tracks'" style="max-width: 85px;">
            <div class="searchTitle">TRACKS</div>
            <v-row>
              <v-col>
                <v-btn @click="getTracks" style="
                    background: rgba(0, 0, 122, 0.1);
                    border: 2px solid #297286;
                  " variant="outlined">
                  <v-icon>mdi-magnify-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="dataType == 'Events'" style="max-width: 85px;">
            <div class="searchTitle">EVENTS</div>
            <v-row>
              <v-col>
                <v-btn @click="getEvents" style="
                    background: rgba(100, 0, 122, 0.1);
                    border: 2px solid #297286;
                  " variant="outlined">
                  <v-icon>mdi-magnify-minus-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col style="max-width: 85px;">
            <div class="searchTitle">RESET</div>
            <v-row>
              <v-col>
                <v-btn @click="resetTaskQuery" style="
                    background: rgba(128, 128, 128, 0.1);
                    border: 2px solid #297286;
                  " variant="outlined" data-cy="query-reset-btn">
                  <v-icon>mdi-checkbox-blank-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="auto">
            <template v-slot:activator="{ props }">
              <v-col md="1" style="max-width: 100px" v-if="dataType == 'Tasks'">
                <div class="searchTitle">HISTORY</div>
                <v-row>
                  <v-col>
                    <v-btn v-bind="props" style="
                        float: left;
                        background: rgba(128, 128, 128, 0.1);
                        border: 2px solid #297286;
                      " variant="outlined">
                      <v-icon>mdi-book-open-variant</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </template>
            <v-card>
              <v-toolbar style="
                  position: sticky;
                  color: rgba(21, 102, 124, 0.9);
                  background-color: rgb(240, 240, 240);
                  border-bottom: 2px solid #2b7588;
                ">
                <v-toolbar-title style="font-weight: bold">
                  {{ study }} Tasks Search History</v-toolbar-title>
                <template v-slot:append>
                  <v-btn icon="mdi-close" text @click="dialog = false"></v-btn>
                </template>
              </v-toolbar>
              <v-table>
                <thead>
                  <tr>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>STAFF</strong>
                    </th>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>STATUS</strong>
                    </th>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>SPID</strong>
                    </th>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>START</strong>
                    </th>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>END</strong>
                    </th>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>SELECT</strong>
                    </th>
                    <th class="text-left" style="color: rgba(21, 102, 124, 0.9)">
                      <strong>DELETE</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(folder, i) in pinHistory" :key="i">
                    <td style="font-weight: bold">
                      <span v-if="folder.staff"> {{ folder.staff }}</span>
                    </td>
                    <td style="font-weight: bold">
                      <span v-for="(piece, j) in folder.status" :key="j">
                        {{ piece }}
                      </span>
                    </td>
                    <td style="font-weight: bold">
                      <span v-if="folder.spid">{{ folder.spid }}</span>
                    </td>
                    <td style="font-weight: bold">{{ folder.startdate }}</td>
                    <td style="font-weight: bold">{{ folder.enddate }}</td>
                    <td>
                      <v-btn @click="selectPin(folder)"
                        style="background: white; border: 2px solid #297286; margin-top: 5px" variant="outlined">
                        <v-icon style="color: rgba(21, 102, 124, 0.9)">
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn @click="deletePin(i)"
                        style="background-color: rgba(122, 0, 0, 0.2);; border: 2px solid #297286; margin-top: 5px"
                        variant="outlined">
                        <v-icon style="color: rgba(21, 102, 124, 0.9)">mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <v-card-actions style="
                  position: sticky;
                  background-color: rgb(240, 240, 240);
                  border-top: 2px solid #2b7588;
                ">
                <v-btn style="
                    background-color: rgba(122, 0, 0, 0.2);
                    border: 2px solid #297286;
                  " variant="outlined" @click="deleteAllPins">
                  Delete All
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-form>
      <v-row no-gutters v-if="tasksView" style="
          padding-top: 5px;
          border-right: 2px solid #297286;
          border-left: 2px solid #297286;
        ">
        <strong><span style="color: rgba(21, 102, 124, 0.9); margin-left: 5px" data-cy="tasks-count">Tasks: {{
            getTaskCount }}
          </span></strong>
        <v-spacer></v-spacer>
        <span>{{ bottomMessage }}</span>
        <v-icon v-on:click="clearAllTasksSortAndFilter()" style="margin-right: 25px">mdi-backup-restore</v-icon>
        <v-icon v-if="btmView === 'Data'" class="allTaskViewIcons"
          style="border-bottom: solid">mdi-format-list-bulleted</v-icon>
        <v-icon v-else @click="btmView = 'Data'" class="allTaskViewIcons">mdi-format-list-bulleted</v-icon>
        <v-icon v-if="btmView === 'Chart'" @click="btmView = 'Chart'" class="allTaskViewIcons"
          style="border-bottom: solid">mdi-chart-pie</v-icon>
        <v-icon v-else @click="btmView = 'Chart'" class="allTaskViewIcons">mdi-chart-pie</v-icon>
        <v-icon v-if="btmView !== 'Chart'" @click="onExportToCsv"
          class="allTaskViewIcons">mdi-file-export-outline</v-icon>
        <v-icon v-on:click="
          changeHeight();
        changeHeightInside();
        " class="allTaskViewIcons">
          mdi-arrow-expand-all
        </v-icon>
      </v-row>
      <v-row no-gutters v-if="tracksView" style="
          background: linear-gradient(0.25turn, #f8f8ff, #e0e0e0, #f8f8ff);
          border-right: 2px solid #297286;
          border-left: 2px solid #297286;
        ">
        <strong><span style="color: rgba(21, 102, 124, 0.9); margin-left: 5px">Results:
            {{ tracksForGrid ? tracksForGrid.length : 0 }}
          </span></strong>
      </v-row>
      <v-row no-gutters v-if="eventsView" style="
          background: linear-gradient(0.25turn, #f8f8ff, #e0e0e0, #f8f8ff);
          border-right: 2px solid #297286;
          border-left: 2px solid #297286;
        ">
        <strong><span style="color: rgba(21, 102, 124, 0.9); margin-left: 5px">Event Reports:
            {{ eventsForGrid ? eventsForGrid.length : 0 }}
          </span></strong>
      </v-row>
      <!-- Bottom table -->

      <div id="underMapArea" class="d-flex" v-bind:style="{ height: computedHeight }" style="
          border-right: 2px solid #297286;
          border-left: 2px solid #297286;
          border-bottom: 2px solid #297286;
        " v-if="tasksView">
        <div class="left hundredWidth" v-if="btmView === 'Data'">
          <AllTaskListView ref="allTaskListComponent" :view="view" :isExporting="isExporting" :study="study"
            @rowsExported="onRowsExported" class="hundredWidth" :heightInside="computedHeightInside"
            @enableDailyCard="setDailyCard"></AllTaskListView>
        </div>
        <div class="left hundredWidth" v-else-if="btmView === 'Chart'">
          <BottomBarChart></BottomBarChart>
        </div>
      </div>
      <div id="underMapArea" class="d-flex" v-bind:style="{ height: computedHeight }" v-if="tracksView">
        <div class="left hundredWidth" v-if="btmView === 'Data'">
          <!-- {{ tracksForGrid }} -->
          <TrackAgregateTable :tracksData="tracksForGrid" :view="view" :isExporting="isExporting" :study="study"
            @rowsExported="onRowsExported" class="hundredWidth" :heightInside="computedHeightInside"
            @updateTrackSummaryCriteria="updateTrackSummaryCriteria"></TrackAgregateTable>
        </div>
      </div>
      <div id="underMapArea" class="d-flex" v-bind:style="{ height: computedHeight }" v-if="eventsView">
        <div class="left hundredWidth" v-if="btmView === 'Data'">
          <EventAgregateTable :eventsData="eventsForGrid" :view="view" :isExporting="isExporting" :study="study"
            @rowsExported="onRowsExported" class="hundredWidth" :heightInside="computedHeightInside"
            @updateTrackSummaryCriteria="updateTrackSummaryCriteria"></EventAgregateTable>
        </div>
      </div>
    </v-main>
    <!-- <Footer></Footer> -->
  </v-layout>
</template>

<script>
// #region imports
import { authService } from "@/services/authService.js";
import router from "@/router";
import { authTokenService } from "@/services/authTokenService.js";
import InterviewerDaySummaryTable from "@/components/InterviewerDaySummaryTable.vue";
import DailyTaskListView from "../components/DailyTaskListView.vue";
import ChartView from "../components/ChartView.vue";
import RouteView from "../components/RouteView.vue";
import ClientEventsView from "../components/ClientEventsView.vue";
import AllTaskListView from "../components/AllTaskListView.vue";
import TrackAgregateTable from "../components/TrackAgregateTable.vue";
import EventAgregateTable from "../components/EventAgregateTable.vue";
import moment from "moment";
import DataByStaff from "../components/DataByStaff.vue";
import { dateService } from "@/services/date.service.js";
import { searchHistoryService } from "@/services/searchHistory.service.js";
import { commonService } from "@/services/common.service.js";
import { criteriaBuilderService } from "@/services/criteria.builder.service.js";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import BottomBarChart from "../components/BottomBarChart.vue";
import { CONSTANTS } from "@/common/constants.js";
import LastReceived from "../components/LastReceived.vue";
import { saveAs } from "file-saver";
import { MAP_CONSTANTS } from "@/common/map.constants.js";
import { STORE_CONSTANTS } from "@/common/store.constants";
import { mapGetters } from "vuex";
import VueDatePicker from "@vuepic/vue-datepicker";
import { ref } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import LeafletMap from "@/components/LeafletMap.vue";
import { clientEventService } from '../services/client.event.service';


// #endregion imports

export default {
  name: "Validation",
  data: () => ({
    STORE_CONSTANTS,
    profile: null,
    studies: null,
    username: null,
    userfullname: null,
    study: "PATH",
    rightColumnDefs: null,
    rightRowData: null,
    bottomColumnDefs: null,
    bottomRowData: null,
    region: null,
    dialog: false,
    record: null,
    showStatusPopover: false,
    showNotesPopover: false,
    selectedRowData: null,
    staffIds: null,
    assignStaffId: null,
    loading: false,
    allowConfirm: false,
    rowSelection: null,
    gridApi: null,
    tab: null,
    type: null,
    allTasks: null,
    task: null,
    view: "Status",
    criteria: {},
    selectedid: CONSTANTS.DEFAULTS.ALLSTAFF,
    status: "SUSPECT",
    mode: null,
    StatusSummary: [],
    lastReceivedC: {},
    interviewerDayCriteria: {},
    setToListView: function () {
      this.type = "listView";
    },
    setToRouteView: function () {
      this.type = "routeView";
    },
    setToCharttView: function () {
      this.type = "chartView";
    },
    picker: ref(dateService.getYesterday()),
    show: false,
    getThisDate: function () {
      // calls getEagle which will refesh the map, calling with 'ALL' for now
      var type = "ALL";
      this.interviewerDayCriteria = {
        study: this.study,
        staffId: this.selectedRowData ? this.selectedRowData.staffId : null,
        startdate: this.picker,
        enddate: this.picker,
      };
      var c = {
        study: this.study,
        status: type, // this.status,
        staffId: this.selectedRowData ? this.selectedRowData.staffId : null,
        startdate: this.picker,
        enddate: this.picker,
        type: type,
        point: this.selectedRowData.point,
      };
      this.getEagleDay(c);
      this.theDateMenu = false;
    },
    drawer: false,
    drawer2: false,
    interviewSummaryView: true,
    btmView: null,
    viewsItems: ["Status", "Staff", "SPID"],
    staffItems: [],
    statusItems: [
      "ALL",
      "CREATED",
      "ASSIGNED",
      "INTERIM",
      "COMPLETED",
      "SUSPECT",
      "UNKNOWN",
      "NO_DATA",
      "VALID",
      "UNDER_REVIEW",
      "FALSIFIED",
      "CORRECTED",
    ],
    footerStartDate: false,
    footerSD: new Date().toISOString().substr(0, 10),
    footerEndDate: false,
    footerED: new Date().toISOString().substr(0, 10),
    computedHeight: "450px",
    computedHeightInside: "450px",
    pinHistory: [],
    staffName: "No Staff Name Selected",
    staffIdSummaryHeader: "",
    spidNumber: "ALL",
    isExporting: false,
    RouteViewCriteria: {},
    selectedUser: null,
    summaryView: "phone",
    APIVersion: null,
    closeOnContentClick: true,
    tracksLoadedTracker: [],
    bottomMessage: null,
    startdate: dateService.getYesterday(),
    enddate: dateService.getCurrentDate(),
    theDateMenu: false,
    dateStartMenu: false,
    dateEndMenu: false,
    advancedSearch: false,
    dataType: "Tasks",
    tracksForGrid: [],
    eventsForGrid:[],
    tracksView: false,
    tasksView: true,
    eventsView: false,
    overlay: false,
    dashboardSuspect: null,
    dashboardUnderReview: null,
    dashboardNoData: null,
    dashboardTaskPct: null,
    dashboardGpsData: null,
    dailyCardDisabled: true
  }),
  components: {
    InterviewerDaySummaryTable,
    DailyTaskListView,
    ChartView,
    RouteView,
    ClientEventsView,
    DataByStaff,
    AllTaskListView,
    TrackAgregateTable,
    EventAgregateTable,
    BottomBarChart,
    LastReceived,
    Header,
    Footer,
    VueDatePicker,
    LeafletMap,
  },
  beforeMount() {
    this.type = "listView";
    this.gridOptions = {};
    this.gridOptionsCases = {};
    this.rowSelection = "single";
    this.btmView = "Data";

    this.getFilteredHistory();

    const me = this;
    commonService
      .getUIAndApiVersion()
      .then(function (response) {
        if (response && response.data) {
          me.APIVersion = response.data.version;
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  },
  beforeUpdate() {
    this.getFilteredHistory();
  },
  watch: {
    picker(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getThisDate();
      }
    },
    isAppIdle(newValue, oldValue) {
      if (newValue === true) {
        authService.logout(true);
      }
    },
    advancedSearch(newValue, oldValue) {
      if (newValue === "false") {
        this.selectedid = CONSTANTS.DEFAULTS.ALLSTAFF;
        this.spidNumber = "ALL";
      }
    },
    dataType(newValue, oldValue) {
      const me = this;
      if (newValue !== oldValue) {
        me.clearAll();
        me.selectedid = CONSTANTS.DEFAULTS.ALLSTAFF;
        me.dailyCardDisabled = true;
      }
      if (newValue === "Tracks") {
        me.tasksView = false;
        me.tracksView = true;
        me.eventsView = false;
      }
      if (newValue === "Tasks") {
        me.tasksView = true;
        me.tracksView = false;
        me.eventsView = false;
      }
      if (newValue === "Events") {
        me.eventsView = true;
        me.tracksView = false;
        me.tasksView = false;
      }
    },
    selectedid(newValue, oldValue) {
      if (!newValue) {
        this.selectedid = CONSTANTS.DEFAULTS.ALLSTAFF;
      }
    },
    study(newValue, oldValue) {
      this.loadMiniDash();
      this.dailyCardDisabled = true;
    },
    startdate(newValue, oldValue) {
      this.loadMiniDash();
    },
    enddate(newValue, oldValue) {
      this.loadMiniDash();
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApiCases = this.gridOptionsCases.api;
    this.gridColumnApiCases = this.gridOptionsCases.columnApi;
  },
  created() {
    window.addEventListener("keydown", this.keyPress);

    // get login user profile
    let profile = authTokenService.getClaims();
    // console.log('profile: ', profile)
    // check if profile exists
    if (profile) {
      // login user
      this.username = profile.username;
      this.userfullname = profile.name;

      // populate study name
      this.study = this.$store.getters["study/getSelectedStudyId"] || authTokenService.getSelectedStudy();
      this.selectStudy(this.study);
      if (!this.study) {
        console.error("Oh boy, looks like you need a study...");
      }
    }

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (
        mutation.type ===
        this.STORE_CONSTANTS.ALL_TASKS.ACTIONS.WITH_NAMESPACE.SET_SELECTED_TASK
      ) {
        let selectedRow = state.allTasks.selectedTask;
        if (selectedRow) {
          this.updateSelectedRow(selectedRow);
        }
      }

      // DD - TODO - BOTH OF THESE BELOW NEED TO BE MOVED OUT TO THEIR NEW COMPONENTS

      // TODO - MOVE TO ALL/PROJECT TASKS SEARCH COMPONENT WHEN IT"S REFACTORED
      if (
        mutation.type ===
        this.STORE_CONSTANTS.ALL_TASKS.MUTATIONS.WITH_NAMESPACE.SET_IS_EXECUTING
      ) {
        const isExecuting = state.allTasks.isExecuting;
        const allStaffLoadingElem = document.getElementById("allStaffLoader");
        if (allStaffLoadingElem) {
          if (isExecuting === true) {
            allStaffLoadingElem.classList.add("universalLoader");
          } else {
            allStaffLoadingElem.classList.remove("universalLoader");
          }
        }
      }

      // TODO - MOVE TO ALL STAFF TASKS SEARCH COMPONENT WHEN IT"S REFACTORED
      if (
        mutation.type ===
        this.STORE_CONSTANTS.DAILY_TASKS.MUTATIONS.WITH_NAMESPACE
          .SET_IS_EXECUTING
      ) {
        const isExecuting = state.dailyTasks.isExecuting;
        const dailyTasksLoadingElem =
          document.getElementById("dailyTasksLoader");

        if (dailyTasksLoadingElem) {
          if (isExecuting === true) {
            dailyTasksLoadingElem.classList.add("universalLoader");
          } else {
            dailyTasksLoadingElem.classList.remove("universalLoader");
          }
        }
      }

      if (
        mutation.type ===
        this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING
      ) {
        const isLoading = state.validation.isLoading;
        const elem = document.getElementById("mapLoader");

        if (elem) {
          const allStaffLoadingElem = document.getElementById("allStaffLoader"),
            dailyTasksLoadingElem = document.getElementById("dailyTasksLoader");

          if (isLoading) {
            //  show

            elem.classList.remove("maploadernoshow");
            elem.classList.add("maploader");
            if (allStaffLoadingElem) {
              allStaffLoadingElem.classList.add("universalLoader");
            }
            if (dailyTasksLoadingElem) {
              dailyTasksLoadingElem.classList.add("universalLoader");
            }
          } else {
            //don't show

            elem.classList.remove("maploader");
            elem.classList.add("maploadernoshow");
            if (allStaffLoadingElem) {
              allStaffLoadingElem.classList.remove("universalLoader");
            }
            if (dailyTasksLoadingElem) {
              dailyTasksLoadingElem.classList.remove("universalLoader");
            }
          }
        }
      }
    });
  },
  destroyed: function () {
    window.removeEventListener("keydown", this.keyPress);
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  computed: {
    staffId: function () {
      if (!this.selectedRowData) {
        return "";
      }
      return this.selectedRowData.staffId;
    },
    ...mapGetters("dailyTasks", ["getTotalTaskCount", "getSuspectTaskCount"]),
    ...mapGetters("allTasks", ["getTaskCount"]),
  },
  // can move most methods into new main.service.js
  methods: {
    clearAll() {
      const me = this;
      // clear map,
      me.clearMapData();
      // clear top right (works, but should eventually be refactored to use store)
      me.interviewerDayCriteria = null;
      // clear bottom Tracks data (works, but should eventually be refactored to use store)
      me.tracksForGrid = [];
      // clear ag-grid tables, AllTaskListView and DailyTaskListView  (use store)
      me.eventsForGrid = [];
      this.$store.dispatch("clearTablesData");
    },
    getFilteredHistory() {
      let filteredHistory = [];
      let myHistory = JSON.parse(localStorage.getItem("history"));

      if (myHistory) {
        for (let piece of myHistory) {
          if (piece.study === this.study) {
            filteredHistory.push(piece);
          }
        }
        this.pinHistory = filteredHistory;
      }
    },
    getPreviousDateSimple: function () {
      this.picker = moment(this.picker).add(-1, "days").format("YYYY-MM-DD");
    },
    getNextDateSimple: function () {
      this.picker = moment(this.picker).add(1, "days").format("YYYY-MM-DD");
    },
    setDailyCard(variable) {
      this.dailyCardDisabled = variable
    },
    /**
     * Handles selection of a row in the track results grid
     */
    updateTrackSummaryCriteria(selection) {
      this.interviewerDayCriteria = {
        study: this.study,
        staffId: selection ? selection.staffIdStaff : null,
        startdate: selection.trackTimeFirst,
        enddate: selection.trackTimeLast,
      };
    },
    style(feature) {
      return {
        fillColor: "green",
        fillOpacity: 0.5,
        weight: 2,
        opacity: 1,
        color: "#ffffff",
        dashArray: "3",
      };
    },
    taskClick(taskData) {
      this.$store.commit(
        this.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE
          .SET_POINT_OF_INTEREST,
        { data: taskData }
      );
    },
    updateSelectedRow: function (val) {
      this.selectedRowData = val;
      if (this.selectedRowData) {
        //Clear the map here just in case we don't get data back
        this.$store.dispatch(
          this.STORE_CONSTANTS.VALIDATION.ACTIONS.WITH_NAMESPACE.CLEAR_MAP_DATA
        );

        this.picker = this.selectedRowData
          ? dateService.formatDateTimeLocalShort(
            this.selectedRowData.dateEnd,
            this.selectedRowData.point
          ) // this gets the correct date
          : null;

        this.selectedUser = this.selectedRowData
          ? this.selectedRowData.staffId
          : null;
        // console.log('summary this.selectedRowData: ', this.selectedRowData)
        this.interviewerDayCriteria = {
          study: this.study,
          staffId: this.selectedRowData ? this.selectedRowData.staffId : null,
          startdate: this.picker,
          enddate: this.picker,
        };

        this.staffName =
          this.selectedRowData.nameFirst + " " + this.selectedRowData.nameLast;
        this.staffIdSummaryHeader = this.selectedRowData.staffId;
        let type = "ALL";
        let critera = {
          study: this.study,
          status: type, // this.status,
          staffId: this.selectedRowData ? this.selectedRowData.staffId : null,
          startdate: this.picker,
          enddate: this.picker,
          type: type,
          point: this.selectedRowData.point,
          taskUUID: this.selectedRowData.taskUUID,
        };

        this.getEagleDay(critera);
        this.lastReceivedC = {
          study: this.study,
          gpssource: "ALL",
          id: this.selectedRowData ? this.selectedRowData.staffId : null,
        };
      } else {
        // if there is no selected row, everything is cleared, including the map
        this.clearAll();
      }
    },
    updateTrackSelectedRow: function (val) {
      this.selectedRowData = val;

      const staff = this.$store.getters['study/getSelectedStudyStaffMap'][this.selectedid];
      if (staff) {
        this.staffName = staff.nameFirst + " " + staff.nameLast;
      }

      this.staffIdSummaryHeader = this.selectedRowData.staffIdStaff;

      this.interviewerDayCriteria = {
        study: this.study,
        staffId: this.selectedRowData ? this.selectedRowData.staffIdStaff : null,
        startdate: this.selectedRowData.trackTimeFirst,
        enddate: this.selectedRowData.trackTimeLast,
      };
    },
    addToHistory() {
      const me = this;
      let query = {
        study: me.study,
        status: me.status,
        staff: me.selectedid,
        spid: me.spidNumber,
        startdate: me.startdate,
        enddate: me.enddate,
        dataType: me.dataType,
      };
      searchHistoryService.saveSearchHistoryItem(
        query,
        query.study,
        "SearchHistory"
      );
      me.getFilteredHistory();
    },
    // function to get results from service
    getTasks() {
      console.log("getTasks me.startdate", this.startdate);
      console.log("getTasks me.enddate", this.enddate);
      const me = this;
      me.overlay = true;
      let query = {
        study: me.study,
        status: me.status,
        staff: me.selectedid,
        spid: me.spidNumber,
        startdate: me.startdate,
        enddate: me.enddate,
        dataType: me.dataType,
      };
      me.$store
        .dispatch(
          me.STORE_CONSTANTS.ALL_TASKS.ACTIONS.WITH_NAMESPACE.GET_TASKS_GENERAL, // allTasks/getTasksGeneral
          query
        )
        .then((data) => {
          me.tasksView = true;
          me.tracksView = false;
          // me.updateSelectedRow(data.selectedRow);
          me.overlay = false;
        })
        .catch((err) => {
          console.error(err);
          me.overlay = false;
        });
    },
    getTracks() {
      const me = this;
      let query = {
        study: me.study,
        staff: me.selectedid,
        startdate: me.startdate,
        enddate: me.enddate,
      };
      this.$store.dispatch('staff/setStaffId', this.selectedid);
      const staff = this.$store.getters['study/getSelectedStudyStaffMap'][this.selectedid];
      if (staff) {
        me.staffName = staff.nameFirst + " " + staff.nameLast;
      }

      console.log("cht getTracks query: ", query);
      me.clearMapData();
      me.$store
        .dispatch(
          me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_TRACKS_AGGREGATE,
          query
        )
        .then((data) => {
          console.log("cht data:", data);
          me.tasksView = false;
          me.tracksView = true;
          if (data[0]) {
            me.updateTrackSelectedRow(data[0]);
          } else {
            me.interviewerDayCriteria = null;
          }
          me.tracksForGrid = data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getEvents() {
  const me = this;
  const query = {
    study: me.study,
    staffId: me.selectedid,
    timeStampStart: me.startdate,
    timeStampEnd: me.enddate,
  };

  const staffMap = me.$store.getters['study/getSelectedStudyStaffMap'] || {};

  const selected = staffMap[me.selectedid];
  if (selected) {
    me.staffName = `${selected.nameFirst} ${selected.nameLast}`;
  }

  me.clearMapData();

  clientEventService.getClientEventsReport(query)
    .then(response => {
      const events = response.data || [];

      me.eventsForGrid = events.map(event => {
        const staff = staffMap[event.staffId];
        return {
          ...event,
          staffName: staff
            ? `${staff.nameFirst} ${staff.nameLast}`.trim()
            : event.staffId, // fall back to the ID if no match
        };
      });

      console.log("Client events report: ", me.eventsForGrid);
    })
    .catch(error => {
      console.error("Error fetching client events: ", error);
    });
},
    selectPin(info) {
      console.log("selectInfo", info);
      this.status = info.status;
      this.selectedid = info.staff;
      this.startdate = info.startdate;
      this.enddate = info.enddate;
      if (info.spid) {
        this.spidNumber = info.spid;
      } else {
        this.spid = "ALL";
      }
      this.getTasks();
      this.dialog = false;
    },
    async deleteAllPins() {
      let study = this.study;
      let key = "SearchHistory";
      await searchHistoryService.deleteAllSearchHistory(study, key);
      this.pinHistory = [];
    },
    async deletePin(i) {
      console.log("i", i);
      let study = this.study;
      let key = "SearchHistory";
      await searchHistoryService.deleteSeachHistoryItem(i, study, key);
      this.pinHistory = JSON.parse(localStorage.getItem("history"));
    },
    getTracksForDay() {
      const me = this;
      const rangeStart = dateService.getStartOfDay(me.selectedRowData.dateEnd);
      const rangeEnd = dateService.getTomorrowEx(me.selectedRowData.dateEnd);
      let criteria = {
        study: me.study,
        staffId: me.selectedRowData.staffId,
        dateStart: rangeStart,
        dateEnd: rangeEnd,
      };

      me.$store.commit(
        me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING,
        true
      );

      me.$store
        .dispatch(
          me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_CLUSTERS_FOR_DAY,
          criteria
        )
        .then((results) => {
          // console.log(results);
        })
        .catch((err) => {
          console.error(err);
        });

      me.$store
        .dispatch(
          me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE
            .GET_ALL_TRACKS_FOR_DAY,
          criteria
        )
        .then((results) => {
          // console.log(results);
          // If we don't get back any tracks (NO DATA), hide loader
          if (!results.tracks) {
            me.$store.commit(
              me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE
                .SET_IS_LOADING,
              false
            );
          }
        })
        .catch((err) => {
          console.error(err);
          me.$store.commit(
            me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE
              .SET_IS_LOADING,
            false
          );
        });
    },
    getEagleDay(criteria) {
      this.$store
        .dispatch("tracks/getTasks", criteria)
        .then(() => {
          console.log("tracks/getTasks succeeded");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectStudy(study) {
      this.study = study;
      this.getFilteredHistory();
      this.clearAll();
      if (this.dataType !== "Tasks") {
        this.dataType = "Tasks";
      }
      this.$store
        .dispatch(
          this.STORE_CONSTANTS.STUDY.ACTIONS.WITH_NAMESPACE.SET_SELECTED_STUDY,
          study
        )
        .then((result) => {
          this.staffItems = result.staff;
        })
        .catch((err) => {
          console.error(err);
        });

      // set the tables and map with a default call for the previous day (3 day spread)
      let myDate = new Date();
      myDate.setDate(myDate.getDate() - 4);
      let myDateFormatStartDate =
        myDate.getFullYear() +
        "-" +
        (myDate.getMonth() < 9
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1) +
        "-" +
        (myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate());
      myDate = new Date();
      myDate.setDate(myDate.getDate() - 1);
      let myDateFormatEndDate =
        myDate.getFullYear() +
        "-" +
        (myDate.getMonth() < 9
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1) +
        "-" +
        (myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate());

      let defaultCall = {
        staffId: "ALLSTAFF",
        startdate: myDateFormatStartDate,
        enddate: myDateFormatEndDate,
        status: ["SUSPECT"],
        study: study,
        spid: "ALL",
      };

      this.selectPin(defaultCall);
    },
    resetTaskQuery() {
      let myDate = new Date();
      myDate.setDate(myDate.getDate() - 4);
      let myDateFormatStartDate =
        myDate.getFullYear() +
        "-" +
        (myDate.getMonth() < 9
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1) +
        "-" +
        (myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate());
      myDate = new Date();
      myDate.setDate(myDate.getDate() - 1);
      let myDateFormatEndDate =
        myDate.getFullYear() +
        "-" +
        (myDate.getMonth() < 9
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1) +
        "-" +
        (myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate());

      let defaultCall = {
        staffId: "ALLSTAFF",
        startdate: myDateFormatStartDate,
        enddate: myDateFormatEndDate,
        status: ["SUSPECT"],
        spid: "ALL",
      };
      this.advancedSearch = false;
      this.status = defaultCall.status;
      this.selectedid = defaultCall.staff;
      this.startdate = defaultCall.startdate;
      this.enddate = defaultCall.enddate;
      this.spidNumber = defaultCall.spid;
    },
    clearMapData() {
      // clear Map
      this.$store.dispatch(
        this.STORE_CONSTANTS.VALIDATION.ACTIONS.WITH_NAMESPACE.CLEAR_MAP_DATA
      );

      // clear InterviewewDaySummarayTable
      this.staffName = "No Staff Name Selected";
      this.staffIdSummaryHeader = "";

      // clear DailyTaskListView tasks
      this.allTasks = [];
      // Turn off radius toggle and reset icon
      const isDrawOn = this.$store.getters['map/isRadiusDrawOn'];
      console.log('Is radius draw ON?', isDrawOn);

      if (isDrawOn) {
        this.$store.dispatch('map/toggleRadiusDrawState', false);
        this.mapLayerGroups['radius'].clearLayers();
      }
    },
    logout() {
      authService.logout(false);
    },
    caseAssignment() {
      router.push("assignment");
    },
    changeHeight: function (event) {
      if (this.computedHeight === "450px") {
        this.computedHeight = "100vh";
      } else if (this.computedHeight === "100vh") {
        this.computedHeight = "450px";
      }
    },
    changeHeightInside: function (event) {
      if (this.computedHeightInside === "450px") {
        this.computedHeightInside = "100vh";
      } else if (this.computedHeightInside === "100vh") {
        this.computedHeightInside = "450px";
      }
    },
    keyPress: function (event) {
      const me = this;
      if (event.key === "Enter") {
        if (event.shiftKey) {
          console.log("shift and endter");
          me.getTasks();
        } else {
          this.dialog = !this.dialog;
        }
      }
    },
    goToEagle() {
      this.$router.push("/validation");
    },
    goToAssignment() {
      this.$router.push("/assignment");
    },
    goToUserManagment() {
      this.$router.push("/management");
    },
    checkIfALL() {
      if (this.status.includes("ALL") && this.status.length > 1) {
        this.status.shift();
      }
      if (this.status[this.status.length - 1] === "ALL") {
        this.status = ["ALL"];
      }
    },
    refreshData() {
      const me = this;
      // keep track of selected index
      me.getTasks();
    },
    onExportToCsv() {
      this.isExporting = true;
    },
    onRowsExported(rows) {
      const blob = new Blob([rows.data], { type: "text/plain;charset=utf-8" });
      saveAs(blob, "staff-table.csv");
      this.isExporting = false;
    },
    clearDailySortAndFilter() {
      this.$refs.dailyTaskListComponent.clearSortAndFilter();
    },
    clearAllTasksSortAndFilter() {
      this.$refs.allTaskListComponent.clearSortAndFilter();
    },
    loadMiniDash() {
      const me = this;
      let criteria = {
        study: me.study,
        startdate: me.startdate,
        enddate: me.enddate
      }
      this.$store
        .dispatch(
          this.STORE_CONSTANTS.STUDY.ACTIONS.WITH_NAMESPACE
            .LOAD_STUDY_TASK_COUNTS, criteria
        )
        .then((result) => {
          me.dashboardSuspect = result.taskCounts.suspect;
          me.dashboardUnderReview = result.taskCounts.under_review;
          me.dashboardNoData = result.taskCounts.no_data;
          me.dashboardTaskPct = result.taskPct;
          me.dashboardGpsData = result.gpsData;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.maploader {
  z-index: 1000000000;
  color: blue;
  background-color: #2c758978;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  display: block !important;
}

#underMapArea {
  margin-left: 0px;
  height: 100%;
}

.center {
  text-align: center;
}

.test-img-style {
  height: 500px;
  width: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.mdb-list-item {
  float: left;
  color: white;
  margin: 0px 5px 0px 0px;
  height: 50px;
}

#myFilter {
  color: rgba(21, 102, 124, 0.9);
}

#topRightCorner {
  color: white;
}

v-list-item {
  color: white;
}

.eagle-theme,
.eagle-theme>.v-card {
  background-color: #17677d !important;
  color: white !important;
  border: none !important;
  box-shadow: none !important;
}

.label {
  text-align: left;
  margin: 6px 0 10px 0;
}

.eagle-icon-btn {
  height: 118px;
  padding: 47px 0;
}

.eagle-item-padded-sides {
  padding: 0 10px;
}

.full-screen-map-container {
  height: 100%;
  width: 100%;
  background-color: red;
  display: block;
}

.full-screen-map-container.hide {
  display: none;
}

.max-v-list-height {
  max-height: 400px;
  overflow-y: auto;
}

.testColumn .col-lg-2 {
  max-width: 10.666667%;
}

.marginZeroPaddingZero {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
}

#bottomRowMarginZeroPaddingZero {
  margin-top: 0px;
  margin-right: 0px;
  /* margin-bottom: 0px; */
  margin-bottom: 50px;
  margin-left: 0px;
  padding: 0px 0px 0px 0px;
  position: relative;
}

.innerDateBox {
  margin-bottom: 10px;
}

#validationCardA {
  border: 1px solid #2b7588;
}

#validationCardB {
  border: 1px solid #2b7588;
}

#validationCardCalendarStart {
  border: 1px solid #2b7588;
  top: 145px;
}

#validationCardCalendarEnd {
  border: 1px solid #2b7588;
  top: 145px;
}

.maploader {
  z-index: 1000000000;
  color: blue;
  background-color: #2c758978;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
}

.maploadernoshow {
  z-index: 1000000000;
  color: blue;
  background-color: #2c758978;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  display: none;
}

.bottom-right {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.clock {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #e0e0e0;
  margin: 10px auto;
  border: 5px solid #2c7589;
  position: relative;
  box-shadow: 0 5px 0 0 rgba(0, 0, 0, 0.3), inset 0 5px 0 0 rgba(0, 0, 0, 0.3),
    inset 0 0 0 34px #e0e0e0;
}

.clock:after {
  content: "";
  width: 2px;
  height: 40px;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: inset 0 2px 0 0 #fff, inset 0 20px 0 0 #2c7589;
  animation: clock 0.5s linear infinite;
}

.clock:before {
  content: "";
  width: 2px;
  height: 30px;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: inset 0 2px 0 0 #fff, inset 0 15px 0 0 #2c7589;
  animation: clockb 6s linear infinite;
}

@keyframes clock {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes clockb {
  100% {
    transform: rotate(360deg);
  }
}

.universalLoader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #17677d76;
  z-index: 100;
}

.middleButttons {
  margin: 5px 5px;
  margin-top: 13px;
  height: 32px !important;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.allTaskViewIcons {
  color: rgba(21, 102, 124, 0.9) !important;
  font-size: larger !important;
}

.dateMenu {
  z-index: 1000000;
}

tbody tr:nth-child(odd) {
  background-color: rgba(21, 102, 124, 0.2);
}
</style>
<style lang="scss">
.dp-custom-input {
  border: none;
  // background:  rgb(224, 224, 224);
  background: rgb(240, 240, 240);
}

.dp-custom-input-bottom {
  // border: grey solid 1px;
  border: 2px solid #297286;
}

.dp-custom-menu {
  box-shadow: 0 0 6px rgba(21, 102, 124, 0.9);
}
</style>
